import * as React from 'react';
import { 
  Box,
  DialogContent,
  CircularProgress,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from '@mui/material';

import { useSelector, useDispatch } from 'react-redux'
import { setVisualization, setLoading } from '../slices/visualization';
import { getUser } from '../slices/auth';
import { CDialog, CDialogTitle, CDialogActions, CButton, CTextField } from '../components/common/Modal';

export default function VisualizationModal(props) {
  const loading = useSelector(state => state.visualization.loading)
  const defaultDb = useSelector(state => state.auth.currentDB);
  const dbs = useSelector(state => state.auth.user.db);

  const {open, handleClose} = props;

  const [title, setTitle] = React.useState("New Visualization");
  const [prompt, setPrompt] = React.useState("");
  const [database, setDatabase] = React.useState(defaultDb);
  const dispatch = useDispatch();

  React.useEffect(() => {
    if(!dbs) {
      dispatch(getUser())
    }
  }, [dbs, dispatch]);

  const handleRequest = (e) => {
    if(prompt === "") {
      window.alert("Please input the prompt.");
      return;
    }

    dispatch(setLoading());  
    dispatch(setVisualization({ db: database, prompt, title }))
    .then(() => {
      handleClose(); // Call handleClose after the setVisualization action has finished
    });
  }

  return (
    <>
      <CDialog
        open={open}
        onClose={handleClose}
        maxWidth={"md"}
        fullWidth
      >
        <CDialogTitle>Visualization</CDialogTitle>
        <DialogContent>
          <CTextField
            id={`title`} 
            label={`Title`}
            size="small"
            rows={3}
            variant="outlined"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            sx={{
              marginTop: '1rem'
            }}
            fullWidth
          />
          <FormControl 
            sx={{
              marginTop: '1rem'
            }} 
            size='small'
            fullWidth
          >
            <InputLabel id="demo-simple-select-label">Data Source</InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={database}
              margin='dense'
              label="Data Source"
              onChange={(e) => setDatabase(e.target.value)}
              fullWidth={true}
              variant='outlined'
              >
                {
                  dbs && dbs.length>0 && dbs.map(item=> (<MenuItem key={item.name} value={item.name}>{item.name}</MenuItem>))
                }
            </Select>
          </FormControl>
          <CTextField
            id={`prompt`} 
            label={`Prompt`}
            size="small"
            multiline
            rows={3}
            variant="outlined"
            value={prompt}
            onChange={(e) => setPrompt(e.target.value)}
            sx={{
              marginTop: '1rem',
            }}
            fullWidth
          />
          {loading && (
            <Box className="absolute w-full h-full" sx={{top: 0, left: 0}}>
              <Box className="relative w-full h-full">
                <Box className="w-full h-full flex justify-center align-center">
                  <CircularProgress sx={{opacity: 0.7}} />
                </Box>
              </Box>
            </Box>)
          }  
        </DialogContent>
        <CDialogActions>
          <CButton onClick={handleClose}>Cancel</CButton>
          <CButton onClick={handleRequest} disabled={loading}>Ok</CButton>
        </CDialogActions>
      </CDialog>
    </>
  )
}